/**
 * In-memory phone handoff that survives auth-store reset on SIGNED_OUT.
 *
 * Used when a signed-in user hits "phone already linked" and chooses
 * "enter with that number": we sign them out of the half-finished account,
 * then seed the phone-login form without putting the number in the URL.
 */

let stagedPhone: string | null = null

export function stagePhoneForLogin(phone: string): void {
  const trimmed = phone.trim()
  stagedPhone = trimmed || null
}

/** Read-and-clear. Call once when phone-login mounts. */
export function takeStagedPhoneForLogin(): string | null {
  const value = stagedPhone
  stagedPhone = null
  return value
}
